module.exports = __webpack_public_path__ + "img/icon-tower.77eaa535.png";